/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetAktResponseBaseLocation,
    GetAktResponseBaseLocationFromJSON,
    GetAktResponseBaseLocationFromJSONTyped,
    GetAktResponseBaseLocationToJSON,
    GetAktResponseBaseType,
    GetAktResponseBaseTypeFromJSON,
    GetAktResponseBaseTypeFromJSONTyped,
    GetAktResponseBaseTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetAktResponseBaseObjects
 */
export interface GetAktResponseBaseObjects {
    /**
     * 
     * @type {number}
     * @memberof GetAktResponseBaseObjects
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseBaseObjects
     */
    description?: string;
    /**
     * 
     * @type {GetAktResponseBaseLocation}
     * @memberof GetAktResponseBaseObjects
     */
    location?: GetAktResponseBaseLocation;
    /**
     * 
     * @type {GetAktResponseBaseType}
     * @memberof GetAktResponseBaseObjects
     */
    type?: GetAktResponseBaseType;
}

export function GetAktResponseBaseObjectsFromJSON(json: any): GetAktResponseBaseObjects {
    return GetAktResponseBaseObjectsFromJSONTyped(json, false);
}

export function GetAktResponseBaseObjectsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAktResponseBaseObjects {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'location': !exists(json, 'location') ? undefined : GetAktResponseBaseLocationFromJSON(json['location']),
        'type': !exists(json, 'type') ? undefined : GetAktResponseBaseTypeFromJSON(json['type']),
    };
}

export function GetAktResponseBaseObjectsToJSON(value?: GetAktResponseBaseObjects | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'description': value.description,
        'location': GetAktResponseBaseLocationToJSON(value.location),
        'type': GetAktResponseBaseTypeToJSON(value.type),
    };
}


